import { events, sourceIDs } from 'analytics/events'
import { useEffect } from 'react'
import { track } from 'utils/analytics'
import ProfileHeading from './AccountHeading'
import AccountIncentives from './AccountIncentives'
import { useUser } from 'contexts/user'
import AccountBalance from './AccountBalance'
import { queries } from '@tovala/browser-apis-combinedapi'
import { useQuery } from '@tanstack/react-query'

const PromosCreditsPage = () => {
  const { user } = useUser()

  const { data: activeIncentives = [] } = useQuery({
    ...queries.users.activeIncentives({ userID: user.id }),
  })

  useEffect(() => {
    track(events.OPENS_PROMOS_AND_CREDITS, {
      source_id: sourceIDs.SETTINGS,
    })
  }, [])

  return (
    <>
      <div className="hidden md:block">
        <ProfileHeading to="/account">Promos & Credits</ProfileHeading>
      </div>
      <div className="flex h-full w-full max-w-account flex-col md:p-4">
        <AccountBalance user={user} />
        <div className="flex-1">
          <AccountIncentives
            activeIncentives={activeIncentives}
            isFreeDessertCustomer={user.isFreeDessertCustomer}
          />
        </div>
      </div>
    </>
  )
}

export default PromosCreditsPage
